import { ServiceProxyMap, createAxiosClient } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/1/invoice-group' }, ServiceProxyMap.PPC_BFF);

export const getInvoiceGroupCount = async (
  invoiceGroupId: string,
  payload: { countType: Array<string>; transactionAccountId: string }
): Promise<{ [key: string]: number }> => {
  const response = await client.post(`/count/${invoiceGroupId}`, payload, {
    validateStatus: (status) => status === 200,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};
